import { Grid, Box, Text, useTheme } from '@simplywallst/ui-core';
import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';

export const ErrorState = () => {
  const theme = useTheme();
  return (
    <Box
      minWidth="288px"
      backgroundColor="noir"
      borderRadius="x1"
      data-testid="portfolio-card-error-state"
      padding="x1"
      height="100%"
    >
      <Grid gap="8px" justifyItems="center" placeContent="center" height="100%">
        <WarningSolid fill={theme.color.bad} />
        <Text typography="small">Portfolio failed to load</Text>
      </Grid>
    </Box>
  );
};
